import { render, staticRenderFns } from "./RouteField.vue?vue&type=template&id=1c7bd792&scoped=true&"
import script from "./RouteField.vue?vue&type=script&lang=js&"
export * from "./RouteField.vue?vue&type=script&lang=js&"
import style0 from "./RouteField.vue?vue&type=style&index=0&id=1c7bd792&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7bd792",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightRoute: require('/opt/buildhome/repo/components/global/FlightRoute.vue').default})
